<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong> Aparencia </strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed = !collapsed">
            <CIcon :name="`cil-chevron-${collapsed ? 'top' : 'bottom'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm enctype="multipart/form-data"> 
              <CRow>
                <CCol lg="6" md="12" xs="12">
                  <h2 class="text-center">Adicione seu Favicon</h2>
                   <uploads 
                    :item="'favicon'"
                    :mimeType="'image.*'" 
                    @images="addImages($event)"  
                  />
                </CCol>
                <CCol lg="6" md="12" xs="12">
                  <h2 class="text-center">Adicione sua Logo</h2>
                    <uploads 
                      :item="'logo'"
                      :mimeType="'image.*'" 
                      @images="addImages($event)"
                    />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6" md="12" xs="12">
                  <h2 class="text-center">Adicione seus banners</h2>
                    <uploads 
                      :item="'banner'"
                      :mimeType="'image.*'" 
                      @images="addImages($event)" 
                    />
                </CCol>
                <CCol lg="6" md="12" xs="12">
                  <h2 class="text-center">Adicione seus arquivos</h2>
                    <uploads 
                      :item="'texto'"
                      :mimeType="'text/plain'" 
                      @images="addImages($event)"
                    />
                </CCol>
              </CRow>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="save()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import uploads from './input-upload'
  export default {
    name: 'appearanceForm',
    components: {
      uploads
    },
    props: {
      show: {
        type: Boolean,
        required: true
      },
      atencao: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        form: {
          id: '1',
          logo: [],
          banner: [],
          textos: [],
          favicon: [],
        },
        url: 'https://drive.google.com/uc?id='
      }
    },
    computed: {
      ...mapState({ aparencia: 'aparencia' }),
      form: {
        get() {
          return this.$store.state.aparencia
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.aparencia 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'aparencia')
        }
      }
    },
    mounted() {
      this.form.id = this.aparencia.id;
    },
    methods: {
      ...mapActions(['saveAparencia']),
      addImages(event) {
        let ref = event.ref;
        switch (ref) {
          case 'favicon':
            this.form.favicon = event.image;
            break;
          case 'logo':
            this.form.logo = event.image;
            break;
          case 'banner':
            this.form.banner = event.image;
            break;
          case 'textos':
            this.form.textos = event.image;
            break;
        }
      },
      async save() {
        let payload = new FormData();
        
        payload.append('id', '1')
        this.form.favicon.forEach(file => {
          payload.append('favicon', file);
        });
        this.form.logo.forEach(file => {
          payload.append('logomarca', file);
        });
        this.form.banner.forEach(file => {
          payload.append('banner', file);
        });
        this.form.textos.forEach(file => {
          payload.append('texto', file);
        });
        
        this.saveAparencia(this.form);
      },
      update() {
        let payload = new FormData();
        
        this.form.favicon.forEach(file => {
          payload.append('favicon', file);
        });
        this.form.logo.forEach(file => {
          payload.append('logomarca', file);
        });
        this.form.banner.forEach(file => {
          payload.append('banner', file);
        });
        this.form.textos.forEach(file => {
          payload.append('texto', file);
        });

        this.updateAppearance(this.form)
      }
    }
  }
</script>
